<template>
  <div id="carousel">
    <b-carousel controls fade indicators :interval="5000" class="seal">
      <b-carousel-slide v-for="slide in slides" :key="slide.key">
        <div slot="img">
          <b-card overlay :img-src="slide.banner" :alt="slide.alt" body-text-variant="blue" text-variant="white">
            <div class="info">
              <div class="logo mb-3 d-none d-lg-block d-xl-block">
                <b-img fluid style="max-width: 70%" :src="permImg.img" :alt="permImg.logoalt" />
              </div>
              <div class="logo  d-sm-block d-md-block d-lg-none">
                <b-img fluid style="max-width: 60%" :src="permImg.img" :alt="permImg.logoalt" />
              </div>
              <h1 class="mb-3 carouseltitle d-none d-md-block font-weight-bold">{{ permImg.title }}</h1>
              <h1 class="carouseltitle d-sm-block d-md-none mob font-weight-bold">{{ permImg.title }}</h1>
              <h3 class=" carouseltitle d-none d-md-block">{{ permImg.subtitle }}</h3>
              <h3 class="mb-3 carouseltitle d-sm-block d-md-none mob">{{ permImg.subtitle }}</h3>
              
              <b-button v-if="!permImg.action.hidden" class="rounded-0 text-white border-0 px-4 py-2 action d-none d-md-block" style="max-width: 65%" variant="primary" :href="permImg.action.web" target="_blank">{{ permImg.action.title }}</b-button>
              <b-button v-if="!permImg.action.hidden" size="sm" class="rounded-1 text-white border-0 px-4 py-2 action d-sm-block d-md-none" style="max-width: 30%" variant="primary" :href="permImg.action.web" target="_blank">{{ permImg.action.smtitle }}</b-button>
            </div>
          </b-card>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  data: () => ({
    slides: [
      {
        key: "slide1",
        rounded: 0,
        banner: require("@/assets/img/Thank-you-demo-banner-v2.2.png"),
        alt: "Thank you for voting",
      },
      
    ],
    permImg: 
      {
        img: require("@/assets/img/Time_To_Renew_Logo.png"),
        logoalt: "Miami-Dade County Public Schools Infinite Possibilities Logo",
        title: "Secure Our Future",
        subtitle: "On the November 8th, 2022 Ballot!",
        action: {
          title: "View Flyer",
          smtitle: "View",
          hidden: false,
          web:'/2022-main-info-flyer.pdf',
        }
      },
  }),
};
</script>

<style lang="scss" scoped>
#carousel ::v-deep .carousel {
  .carousel-indicators {
    li {
      background-color: transparent;
      border: 2px solid white;
      border-radius: 50%;
      width: 8px;
      height: 8px;
      background-clip: inherit;
      opacity: 1;
      margin-left: 7px;
      margin-right: 7px;

      &.active {
        background-color: white;
      }
    }
  }
  .seal {
    width: 100%;
  }

  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-next {
    justify-content: flex-end;
    padding: 0.1vw;
  }
  .carousel-control-prev {
    justify-content: flex-start;
    padding: 0.1vw;
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    margin: 0 1rem;
    border: 8px solid white;
    border-radius: 50%;
    background-color: white;
    opacity: 0.8;
    padding: 0.8rem;
    transition: opacity 0.5s ease;

    &:hover {
      opacity: 1;
    }
  }

  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180)'%3E%3C/path%3E%3C/svg%3E");
  }

  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z' class='arrow'%3E%3C/path%3E%3C/svg%3E");
  }
}

.info {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 40vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 5vw;
  overflow: hidden;
  align-items: center;
  justify-content: center;

  .logo {
    img {
      width: 80%;
      height: 100%;
      object-fit: contain;
      object-position: bottom;
    }
  }

  .action {
    margin-bottom: 3vw;
  }
}

@media screen and (max-width: 1100px) {
  .action {
    min-width: 20vw;
    padding: 0vw;
  }
  h1 {
    font-size: medium;
  };
  h3 {
    font-size: medium;
  }
}
@media screen and (max-width: 500px) {
  #carousel ::v-deep .carousel {
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      opacity: 0%;
    }
    .action {
      min-width: 30vw;
      max-height: 25%;
      margin-top: -3vw;
    }
    .carouseltitle {
      min-width: -45px;
    } } }
    
    @media screen and (max-width: 1000px) {

    h1
    {
      font-size:small;
      padding: 0px;
      margin:0px;
    }
    h3
    {
      font-size:small;
      padding: 0px;
      margin:0px;
    }
}
</style>